<template>
    <div class="p-8">
        <div class="flex flex-col gap-4">
            <h1 class="text-2xl font-bold mb-6">Codes Details Report Generator</h1>
            <label class="font-semibold">Select Date Range:</label>
            <span class="text-sm text-gray-500">All times in US Eastern Time Zone</span>
            <div class="flex gap-4">
                <input type="date" v-model="startDate" class="input input-bordered w-full max-w-xs"
                    placeholder="Start Date" />
                <input type="date" v-model="endDate" class="input input-bordered w-full max-w-xs"
                    placeholder="End Date" />
            </div>

            <button class="btn btn-primary w-full max-w-xs mt-4" :disabled="!isButtonActive" @click="fetchData(startDate, endDate)">
                Generate Report
            </button>
        </div>

        <hr class="my-8 border-t-2 border-gray-200" />

        <div v-if="loading" class="flex flex-col items-center">
            <span class="loading loading-spinner loading-lg"></span>
            <p class="text-gray-500 mt-2">Data is being retrieved...</p>
        </div>

        <div v-if="data.length > 0 && !loading" class="overflow-x-auto mt-6">
            <table class="table table-zebra w-full">
                <thead>
                    <tr>
                        <th>Code</th>
                        <th>Registrations</th>
                        <th>FTPs</th>
                        <th>GGR (SC)</th>
                        <th>Purchases ($)</th>
                        <th>Redemptions ($)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in data" :key="index">
                        <td>{{ formatNumber(row.code) }}</td>
                        <td>{{ formatNumber(row.registrations) }}</td>
                        <td>{{ formatNumber(row.ftp) }}</td>
                        <td>{{ formatNumber(row.ggr) }}</td>
                        <td>{{ formatCurrency(row.purchases) }}</td>
                        <td>{{ formatCurrency(row.redemptions) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'PromoCodeView',
    data() {
        return {
            startDate: null,
            endDate: null,
            loading: false,
            data: []
        }
    },
    computed: {
        isButtonActive() {
            if (!this.startDate || !this.endDate) return false
            const start = new Date(this.startDate)
            const end = new Date(this.endDate)
            const now = new Date()
            return start < end && start <= now
        }
    },
    methods: {
        formatNumber(value) {
            if (value == null) return '0';
            return value.toLocaleString();
        },
        formatCurrency(value) {
            if (value == null) return '$0';
            return `$${value.toLocaleString()}`;
        },
        async fetchData(start, end) {
            this.loading = true;
            this.dataLoaded = false;

            const token = this.$store.getters['access_token'];
            const url = `${process.env.VUE_APP_API_GATEWAY_URL}/stats/details`;

            try {
                const response = await axios.get(url, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: { start, end },
                });

                this.data = response.data;
            } catch (error) {
                if (error.code === 'ECONNABORTED') {
                    console.error('Request timed out:', error.message);
                } else {
                    console.error('Error details:', {
                        message: error.message,
                        code: error.code,
                        response: error.response?.data,
                        config: error.config,
                    });
                }
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>
